import { create } from 'zustand';

interface TpSlState {
  tp: number | null
  sl: number | null
  entryPrice: number | null
  setTp: (price: number | null) => void
  setSl: (price: number | null) => void
  setEntry: (price: number | null) => void
  clear: () => void
}

// Transient state only. TP/SL/entry belong to a position, not to a chart
// symbol — the host re-applies them whenever a position becomes active, so
// we don't persist across reloads.
export const useTpSlStore = create<TpSlState>((set) => ({
  tp: null,
  sl: null,
  entryPrice: null,
  setTp: (price) => set({ tp: price }),
  setSl: (price) => set({ sl: price }),
  setEntry: (price) => set({ entryPrice: price }),
  clear: () => set({ tp: null, sl: null, entryPrice: null }),
}));
